import { render, staticRenderFns } from "./DashboardMetric.vue?vue&type=template&id=bc011bf6&scoped=true&"
import script from "./DashboardMetric.vue?vue&type=script&lang=ts&"
export * from "./DashboardMetric.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardMetric.vue?vue&type=style&index=0&id=bc011bf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc011bf6",
  null
  
)

export default component.exports